import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object().shape({
  address: yup.string().required("Address is required"),
  city: yup.string().required("City is required"),
  state: yup.string().required("State is required"),
  zip: yup
    .string()
    .matches(/^\d{5}(-\d{4})?$/, "Invalid ZIP code")
    .required("ZIP code is required"),
  country: yup.string().required("Country is required"),
});

const AddressInfoForm = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {
    console.log("Address Info Submitted:", data);
    // API call or state update here
  };

  const onReset = () => reset();

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block">Address</label>
          <input
            {...register("address")}
            className={`form-input w-full ${errors.address ? "border-red-500" : ""}`}
            placeholder="Street address"
          />
          <p className="text-red-500 text-sm">{errors.address?.message}</p>
        </div>

        <div>
          <label className="block">City</label>
          <input
            {...register("city")}
            className={`form-input w-full ${errors.city ? "border-red-500" : ""}`}
            placeholder="City"
          />
          <p className="text-red-500 text-sm">{errors.city?.message}</p>
        </div>

        <div>
          <label className="block">State</label>
          <input
            {...register("state")}
            className={`form-input w-full ${errors.state ? "border-red-500" : ""}`}
            placeholder="State"
          />
          <p className="text-red-500 text-sm">{errors.state?.message}</p>
        </div>

        <div>
          <label className="block">Zip</label>
          <input
            {...register("zip")}
            className={`form-input w-full ${errors.zip ? "border-red-500" : ""}`}
            placeholder="Zip code"
          />
          <p className="text-red-500 text-sm">{errors.zip?.message}</p>
        </div>

        <div>
          <label className="block">Country</label>
          <input
            {...register("country")}
            className={`form-input w-full ${errors.country ? "border-red-500" : ""}`}
            placeholder="Country"
          />
          <p className="text-red-500 text-sm">{errors.country?.message}</p>
        </div>
      </div>

      <div className="flex gap-2">
        <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
          Save changes
        </button>
        <button type="button" className="btn btn-danger" onClick={onReset}>
          Cancel
        </button>
      </div>
    </form>
  );
};

export default AddressInfoForm;
